<app-shared-dialog
  [title]="(isUpdate ? 'knowledge_base.preferred_products.dialog.title_edit' : 'knowledge_base.preferred_products.dialog.title_create') | translate"
  [options]="{
    cancelText: 'common.cancel' | translate,
    customConfirmButton: true
  }"
  (cancel)="close()"
>
  <form class="information-form" [formGroup]="form">
    <div class="form-content">
      <!-- Description -->
      <p class="preferred-product-modal__description">
        {{ "knowledge_base.preferred_products.dialog.description" | translate }}
      </p>

      <!-- Customer (required, locked on edit) -->
      <div class="standard-input">
        <label>{{ "knowledge_base.preferred_products.dialog.customer" | translate }}</label>
        <div class="autocomplete-wrapper">
          <input
            type="text"
            class="is-autocomplete"
            [formControl]="customerSearchControl"
            [matAutocomplete]="customerAuto"
            [placeholder]="'knowledge_base.preferred_products.dialog.customer_placeholder' | translate"
          />
          <button
            *ngIf="customerSearchControl.value && !isUpdate && (canSubmit$ | async) && !(submitting$ | async)"
            type="button"
            class="autocomplete-clear"
            (click)="clearCustomer(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-autocomplete #customerAuto="matAutocomplete" [displayWith]="displayOptionFn" (optionSelected)="onCustomerSelected($event.option.value)">
          <mat-option *ngIf="customerSearchState === 'idle'" disabled>
            {{ "knowledge_base.preferred_products.dialog.start_typing" | translate }}
          </mat-option>
          <mat-option *ngFor="let customer of filteredCustomers$ | async" [value]="customer">
            {{ customer.label }}
          </mat-option>
          <mat-option *ngIf="customerSearchState === 'results' && (filteredCustomers$ | async)?.length === 0" disabled>
            {{ "knowledge_base.preferred_products.dialog.no_customers" | translate }}
          </mat-option>
        </mat-autocomplete>
        <div class="error" *ngIf="form.get('customer_id')?.invalid && (form.get('customer_id')?.touched || form.get('customer_id')?.dirty)">
          <small *ngIf="form.get('customer_id')?.hasError('required')">{{ "validation.required" | translate }}</small>
        </div>
      </div>

      <!-- Product (required, locked on edit) -->
      <div class="standard-input">
        <label>{{ "knowledge_base.preferred_products.dialog.product" | translate }}</label>
        <div class="autocomplete-wrapper">
          <input
            type="text"
            class="is-autocomplete"
            [formControl]="productSearchControl"
            [matAutocomplete]="productAuto"
            [placeholder]="'knowledge_base.preferred_products.dialog.product_placeholder' | translate"
          />
          <button
            *ngIf="productSearchControl.value && !isUpdate && (canSubmit$ | async) && !(submitting$ | async)"
            type="button"
            class="autocomplete-clear"
            (click)="clearProduct(); $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-autocomplete #productAuto="matAutocomplete" [displayWith]="displayOptionFn" (optionSelected)="onProductSelected($event.option.value)">
          <mat-option *ngIf="productSearchState === 'idle'" disabled>
            {{ "knowledge_base.preferred_products.dialog.start_typing" | translate }}
          </mat-option>
          <mat-option *ngFor="let product of filteredProducts$ | async" [value]="product">
            {{ product.label }}
          </mat-option>
          <mat-option *ngIf="productSearchState === 'results' && (filteredProducts$ | async)?.length === 0" disabled>
            {{ "knowledge_base.preferred_products.dialog.no_products" | translate }}
          </mat-option>
        </mat-autocomplete>
        <div class="error" *ngIf="form.get('product_id')?.invalid && (form.get('product_id')?.touched || form.get('product_id')?.dirty)">
          <small *ngIf="form.get('product_id')?.hasError('required')">{{ "validation.required" | translate }}</small>
        </div>
      </div>

      <!-- Purchase frequency (optional, defaults to 1) -->
      <div class="standard-input">
        <label>
          {{ "knowledge_base.preferred_products.dialog.purchase_frequency" | translate }}
          <span class="preferred-product-modal__optional">{{ "knowledge_base.preferred_products.dialog.purchase_frequency_hint" | translate }}</span>
        </label>
        <ui-form-field
          type="number"
          formControlName="purchase_frequency"
          [min]="1"
          [disabled]="!(canSubmit$ | async) || !!(submitting$ | async)"
          [errorMessages]="{ min: ('validation.numeric_only' | translate) }"
        >
        </ui-form-field>
      </div>
    </div>
  </form>
  <ui-button
    customConfirm
    *appHasPermission="submitPermission()"
    type="primary"
    [label]="(isUpdate ? 'common.update' : 'common.create') | translate"
    icon="arrow-right"
    iconPosition="end"
    [disabled]="!!(submitting$ | async)"
    (click)="save()"
  >
  </ui-button>
</app-shared-dialog>
